module.exports = __webpack_public_path__ + "media/images/vendors/category4-368b16a3c938bd4712495d976b2e56eb.jpg";